import { FilterConfig } from 'common/models/filter.model';
import { GLOBAL_FILTERS } from './constants';
import { FILTER_ITEMS } from './constants-filter-configs';

export const INTERACTION_FILTER: FilterConfig[] = [
  FILTER_ITEMS.dateRange,
  ...GLOBAL_FILTERS,
  FILTER_ITEMS.channel,
  FILTER_ITEMS.interactionType,
  FILTER_ITEMS.topic,
  FILTER_ITEMS.tags,
];

export const INTERACTION_SEGMENT_FILTER: FilterConfig[] = [FILTER_ITEMS.total];
